import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./Footer.css"
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer-color text-white pt-5 pb-3">
      <Container>
        <Row className="mb-4">
          {/* Logo + About */}
          <Col md={4} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <img
                src="/images/BDElogo-removebg-preview.jpg"
                 alt="Bangalore distance education footer logo"

                style={{ height: "40px", marginRight: "10px" }}
              />
              <span className="fw-bold fs-5">
                Bangalore <span style={{color:"#DD4526"}}>Distance Education</span>
              </span>
            </div>
            <p>
              <strong>Bangalore Distance Education</strong> helps students and
              professionals enroll in UGC-approved online and distance learning
              programs from top universities.
            </p>
          </Col>

          {/* Quick Links */}
          <Col md={2} className="mb-4">
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-white text-decoration-none">→ Home</Link></li>
              <li><Link to="/about" className="text-white text-decoration-none">→ About Us</Link></li>
              <li><Link to="/blog" className="text-white text-decoration-none">→ Blog</Link></li>
              <li><Link to="/bosse" className="text-white text-decoration-none">→ BOSSE</Link></li>
              <li><Link to="/contact" className="text-white text-decoration-none">→ Contact Us</Link></li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col md={3} className="mb-4">
            <h5 className="fw-bold mb-3">Contact Us</h5>
            <p><FaPhoneAlt className="me-2" /> +91 9035600400</p>
            <p><FaWhatsapp className="me-2" /> +91 9035600400</p>
            <p><FaEnvelope className="me-2" /> info@educareer360.com</p>
            <p><FaMapMarkerAlt className="me-2" /> Headquarter Hennur Road, Bangalore</p>
          </Col>

          {/* Social Media */}
          <Col md={3} className="mb-4">
            <h5 className="fw-bold mb-3">Follow Us On</h5>
            <div className="d-flex gap-3">
              <a href="#" className="text-white fs-5"><FaFacebookF /></a>
              <a href="#" className="text-white fs-5"><FaInstagram /></a>
              <a href="#" className="text-white fs-5"><FaLinkedinIn /></a>
              <a href="#" className="text-white fs-5"><FaYoutube /></a>
            </div>
          </Col>
        </Row>

        <hr className="border-light" />
        <Row>
          <Col className="text-center">
            <p className="mb-0">
              Copyright © 2025 Bangalore Distance Education | Maintained By{" "}
              <a
                href="https://zentelex.com"
                className="text-warning text-decoration-none"
              >
                Zentelex Pvt. Ltd.
              </a>{" "}
              | All Rights Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
